"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Button = _interopRequireDefault(require("../Button"));
var _default = exports["default"] = function _default(_ref) {
  var name = _ref.name,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8 bg-card",
    style: {
      width: 400
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-2xl text-dark font-bold text-center break-words"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "settings.label.prompt.remove",
    values: {
      name: name
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-around mt-10"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    color: "secondary",
    className: "w-2/5",
    onClick: onClose
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    className: "w-2/5",
    onClick: onConfirm
  }, t('button.delete'))));
};
//# sourceMappingURL=LabelPrompt.js.map